import React from 'react';

import './Loader.css';

const Loader = props => (
  <div className={props.loaderStyle ? props.loaderStyle : "loader"}>
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Loader;
